export const toggleSearch = () => {
    const searchToggle = document.getElementById('sp-search-toggle');
    const searchWrap = document.getElementById('sp-search');
    const searchInput = document.getElementById('sp-search-term');
    const navToggle = document.getElementById('sp-main-toggle');
    const navExpanded = navToggle.getAttribute('aria-expanded');

    const isSearchHidden = () =>
        searchWrap.classList.contains('sp-search-hidden');

    searchToggle.addEventListener('click', function () {
        if (navExpanded === 'true') {
            navToggle.click();
        }

        const expanded =
            searchToggle.getAttribute('aria-expanded') === 'true'
                ? true
                : false;
        const hidden = isSearchHidden();

        searchToggle.setAttribute('aria-expanded', !expanded);
        searchWrap.classList.toggle('sp-search-hidden');

        if (hidden) {
            searchInput.focus();
        } else {
            searchInput.blur();
        }
    });

    document.body.addEventListener(
        'click',
        function (e) {
            if (
                isSearchHidden() ||
                e.target.closest('#sp-search-toggle') ||
                e.target.closest('#sp-searchbar')
            )
                return;

            searchToggle.setAttribute('aria-expanded', 'false');
            searchWrap.classList.add('sp-search-hidden');
            searchInput.blur();
        },
        false
    );
};
